 // =================================================================
 // RAÍZ CUADRADA — PHONE CODES LIBRARY
 // Constants: Country codes and Mexico internal codes
 // =================================================================
 
 import { PhoneCode, InternalCode } from './types';
 
 export const MEXICO_INTERNAL_CODES: InternalCode[] = [
   // CDMX y Área Metropolitana
   { code: '55', location: 'Ciudad de México', state: 'CDMX', type: 'both', timezone: 'America/Mexico_City', format: 'xx xx xx xx' },
   { code: '56', location: 'Ciudad de México (Sur)', state: 'CDMX', type: 'both', timezone: 'America/Mexico_City', format: 'xx xx xx xx' },
   
   // Estados - Zona Centro
   { code: '33', location: 'Guadalajara', state: 'Jalisco', type: 'both', timezone: 'America/Mexico_City', format: 'xxxx xxxx' },
   { code: '222', location: 'Puebla', state: 'Puebla', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '442', location: 'Querétaro', state: 'Querétaro', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '477', location: 'León', state: 'Guanajuato', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '449', location: 'Aguascalientes', state: 'Aguascalientes', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   
   // Norte
   { code: '81', location: 'Monterrey', state: 'Nuevo León', type: 'both', timezone: 'America/Monterrey', format: 'xxxx xxxx' },
   { code: '656', location: 'Ciudad Juárez', state: 'Chihuahua', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '614', location: 'Chihuahua', state: 'Chihuahua', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '667', location: 'Culiacán', state: 'Sinaloa', type: 'both', timezone: 'America/Mazatlan', format: 'xxx xxxx' },
   { code: '669', location: 'Mazatlán', state: 'Sinaloa', type: 'both', timezone: 'America/Mazatlan', format: 'xxx xxxx' },
   { code: '871', location: 'Torreón', state: 'Coahuila', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '844', location: 'Saltillo', state: 'Coahuila', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '868', location: 'Reynosa', state: 'Tamaulipas', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   
   // Sur y Sureste
   { code: '999', location: 'Mérida', state: 'Yucatán', type: 'both', timezone: 'America/Merida', format: 'xxx xxxx' },
   { code: '998', location: 'Cancún', state: 'Quintana Roo', type: 'both', timezone: 'America/Cancun', format: 'xxx xxxx' },
   { code: '984', location: 'Playa del Carmen', state: 'Quintana Roo', type: 'both', timezone: 'America/Cancun', format: 'xxx xxxx' },
   { code: '993', location: 'Villahermosa', state: 'Tabasco', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '961', location: 'Tuxtla Gutiérrez', state: 'Chiapas', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '951', location: 'Oaxaca', state: 'Oaxaca', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   
   // Occidente y Pacífico
   { code: '322', location: 'Puerto Vallarta', state: 'Jalisco', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   { code: '624', location: 'Los Cabos', state: 'Baja California Sur', type: 'both', timezone: 'America/Mazatlan', format: 'xxx xxxx' },
   { code: '664', location: 'Tijuana', state: 'Baja California', type: 'both', timezone: 'America/Tijuana', format: 'xxx xxxx' },
   { code: '686', location: 'Mexicali', state: 'Baja California', type: 'both', timezone: 'America/Tijuana', format: 'xxx xxxx' },
   { code: '443', location: 'Morelia', state: 'Michoacán', type: 'both', timezone: 'America/Mexico_City', format: 'xxx xxxx' },
   
   // Especiales
   { code: '800', location: 'Lada Gratuita', type: 'toll-free', format: 'xxx xxxx' },
   { code: '900', location: 'Servicios Premium', type: 'premium', format: 'xxx xxxx' },
 ];
 
 export const COMMON_PHONE_CODES: PhoneCode[] = [
   // México (principal)
   {
     code: '+52',
     country: 'México',
     countryEn: 'Mexico',
     iso2: 'MX',
     iso3: 'MEX',
     dialCode: '52',
     internalCodes: MEXICO_INTERNAL_CODES,
     flag: '🇲🇽',
     format: 'xx xxxx xxxx',
     timezone: 'America/Mexico_City',
     language: 'Español'
   },
   
   // Estados Unidos
   {
     code: '+1',
     country: 'Estados Unidos',
     countryEn: 'United States',
     iso2: 'US',
     iso3: 'USA',
     dialCode: '1',
     flag: '🇺🇸',
     format: '(xxx) xxx-xxxx',
     timezone: 'America/New_York',
     language: 'English',
     isCommonMigrant: true
   },
   
   // Canadá
   {
     code: '+1',
     country: 'Canadá',
     countryEn: 'Canada',
     iso2: 'CA',
     iso3: 'CAN',
     dialCode: '1',
     flag: '🇨🇦',
     format: '(xxx) xxx-xxxx',
     timezone: 'America/Toronto',
     language: 'English/French',
     isCommonMigrant: true
   },
   
   // Centroamérica
   {
     code: '+502',
     country: 'Guatemala',
     countryEn: 'Guatemala',
     iso2: 'GT',
     iso3: 'GTM',
     dialCode: '502',
     flag: '🇬🇹',
     format: 'xxxx xxxx',
     timezone: 'America/Guatemala',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+503',
     country: 'El Salvador',
     countryEn: 'El Salvador',
     iso2: 'SV',
     iso3: 'SLV',
     dialCode: '503',
     flag: '🇸🇻',
     format: 'xxxx xxxx',
     timezone: 'America/El_Salvador',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+504',
     country: 'Honduras',
     countryEn: 'Honduras',
     iso2: 'HN',
     iso3: 'HND',
     dialCode: '504',
     flag: '🇭🇳',
     format: 'xxxx xxxx',
     timezone: 'America/Tegucigalpa',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+505',
     country: 'Nicaragua',
     countryEn: 'Nicaragua',
     iso2: 'NI',
     iso3: 'NIC',
     dialCode: '505',
     flag: '🇳🇮',
     format: 'xxxx xxxx',
     timezone: 'America/Managua',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+506',
     country: 'Costa Rica',
     countryEn: 'Costa Rica',
     iso2: 'CR',
     iso3: 'CRI',
     dialCode: '506',
     flag: '🇨🇷',
     format: 'xxxx xxxx',
     timezone: 'America/Costa_Rica',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+507',
     country: 'Panamá',
     countryEn: 'Panama',
     iso2: 'PA',
     iso3: 'PAN',
     dialCode: '507',
     flag: '🇵🇦',
     format: 'xxxx xxxx',
     timezone: 'America/Panama',
     language: 'Español',
     isCommonMigrant: true
   },
   
   // Sudamérica
   {
     code: '+51',
     country: 'Perú',
     countryEn: 'Peru',
     iso2: 'PE',
     iso3: 'PER',
     dialCode: '51',
     flag: '🇵🇪',
     format: 'xxx xxx xxx',
     timezone: 'America/Lima',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+56',
     country: 'Chile',
     countryEn: 'Chile',
     iso2: 'CL',
     iso3: 'CHL',
     dialCode: '56',
     flag: '🇨🇱',
     format: 'x xxxx xxxx',
     timezone: 'America/Santiago',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+57',
     country: 'Colombia',
     countryEn: 'Colombia',
     iso2: 'CO',
     iso3: 'COL',
     dialCode: '57',
     flag: '🇨🇴',
     format: 'xxx xxx xxxx',
     timezone: 'America/Bogota',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+58',
     country: 'Venezuela',
     countryEn: 'Venezuela',
     iso2: 'VE',
     iso3: 'VEN',
     dialCode: '58',
     flag: '🇻🇪',
     format: 'xxx xxx xxxx',
     timezone: 'America/Caracas',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+593',
     country: 'Ecuador',
     countryEn: 'Ecuador',
     iso2: 'EC',
     iso3: 'ECU',
     dialCode: '593',
     flag: '🇪🇨',
     format: 'xx xxx xxxx',
     timezone: 'America/Guayaquil',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+54',
     country: 'Argentina',
     countryEn: 'Argentina',
     iso2: 'AR',
     iso3: 'ARG',
     dialCode: '54',
     flag: '🇦🇷',
     format: 'xx xxxx xxxx',
     timezone: 'America/Argentina/Buenos_Aires',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+55',
     country: 'Brasil',
     countryEn: 'Brazil',
     iso2: 'BR',
     iso3: 'BRA',
     dialCode: '55',
     flag: '🇧🇷',
     format: '(xx) xxxxx-xxxx',
     timezone: 'America/Sao_Paulo',
     language: 'Portugués',
     isCommonMigrant: true
   },
   {
     code: '+591',
     country: 'Bolivia',
     countryEn: 'Bolivia',
     iso2: 'BO',
     iso3: 'BOL',
     dialCode: '591',
     flag: '🇧🇴',
     format: 'x xxx xxxx',
     timezone: 'America/La_Paz',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+595',
     country: 'Paraguay',
     countryEn: 'Paraguay',
     iso2: 'PY',
     iso3: 'PRY',
     dialCode: '595',
     flag: '🇵🇾',
     format: 'xxx xxx xxx',
     timezone: 'America/Asuncion',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+598',
     country: 'Uruguay',
     countryEn: 'Uruguay',
     iso2: 'UY',
     iso3: 'URY',
     dialCode: '598',
     flag: '🇺🇾',
     format: 'x xxx xxxx',
     timezone: 'America/Montevideo',
     language: 'Español',
     isCommonMigrant: true
   },
   
   // Caribe
   {
     code: '+53',
     country: 'Cuba',
     countryEn: 'Cuba',
     iso2: 'CU',
     iso3: 'CUB',
     dialCode: '53',
     flag: '🇨🇺',
     format: 'x xxx xxxx',
     timezone: 'America/Havana',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+1809',
     country: 'República Dominicana',
     countryEn: 'Dominican Republic',
     iso2: 'DO',
     iso3: 'DOM',
     dialCode: '1809',
     flag: '🇩🇴',
     format: '(xxx) xxx-xxxx',
     timezone: 'America/Santo_Domingo',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+509',
     country: 'Haití',
     countryEn: 'Haiti',
     iso2: 'HT',
     iso3: 'HTI',
     dialCode: '509',
     flag: '🇭🇹',
     format: 'xx xx xxxx',
     timezone: 'America/Port-au-Prince',
     language: 'Francés/Criollo',
     isCommonMigrant: true
   },
   
   // Europa
   {
     code: '+34',
     country: 'España',
     countryEn: 'Spain',
     iso2: 'ES',
     iso3: 'ESP',
     dialCode: '34',
     flag: '🇪🇸',
     format: 'xxx xxx xxx',
     timezone: 'Europe/Madrid',
     language: 'Español',
     isCommonMigrant: true
   },
   {
     code: '+33',
     country: 'Francia',
     countryEn: 'France',
     iso2: 'FR',
     iso3: 'FRA',
     dialCode: '33',
     flag: '🇫🇷',
     format: 'x xx xx xx xx',
     timezone: 'Europe/Paris',
     language: 'Francés'
   },
   {
     code: '+49',
     country: 'Alemania',
     countryEn: 'Germany',
     iso2: 'DE',
     iso3: 'DEU',
     dialCode: '49',
     flag: '🇩🇪',
     format: 'xxxx xxxxxxx',
     timezone: 'Europe/Berlin',
     language: 'Alemán'
   },
   {
     code: '+39',
     country: 'Italia',
     countryEn: 'Italy',
     iso2: 'IT',
     iso3: 'ITA',
     dialCode: '39',
     flag: '🇮🇹',
     format: 'xxx xxxxxxx',
     timezone: 'Europe/Rome',
     language: 'Italiano'
   },
   {
     code: '+44',
     country: 'Reino Unido',
     countryEn: 'United Kingdom',
     iso2: 'GB',
     iso3: 'GBR',
     dialCode: '44',
     flag: '🇬🇧',
     format: 'xxxx xxx xxx',
     timezone: 'Europe/London',
     language: 'English'
   },
   
   // Asia
   {
     code: '+86',
     country: 'China',
     countryEn: 'China',
     iso2: 'CN',
     iso3: 'CHN',
     dialCode: '86',
     flag: '🇨🇳',
     format: 'xxx xxxx xxxx',
     timezone: 'Asia/Shanghai',
     language: 'Chino'
   },
   {
     code: '+81',
     country: 'Japón',
     countryEn: 'Japan',
     iso2: 'JP',
     iso3: 'JPN',
     dialCode: '81',
     flag: '🇯🇵',
     format: 'xx xxxx xxxx',
     timezone: 'Asia/Tokyo',
     language: 'Japonés'
   },
   {
     code: '+82',
     country: 'Corea del Sur',
     countryEn: 'South Korea',
     iso2: 'KR',
     iso3: 'KOR',
     dialCode: '82',
     flag: '🇰🇷',
     format: 'xx xxxx xxxx',
     timezone: 'Asia/Seoul',
     language: 'Coreano'
   },
   
   // Oceanía
   {
     code: '+61',
     country: 'Australia',
     countryEn: 'Australia',
     iso2: 'AU',
     iso3: 'AUS',
     dialCode: '61',
     flag: '🇦🇺',
     format: 'x xxxx xxxx',
     timezone: 'Australia/Sydney',
     language: 'English'
   },
 ];
 
 // Códigos especiales
 export const SPECIAL_CODES = {
   EMERGENCY: ['911', '066', '060', '068'],
   TOLL_FREE: ['800', '888', '877', '866'],
   PREMIUM: ['900'],
   MOBILE_PREFIXES: ['044', '045'],
   INTERNATIONAL_PREFIX: '00',
   NATIONAL_PREFIX: '01',
 } as const;
 
 // Expresiones regulares para validación
 export const PHONE_REGEX = {
   MEXICO_MOBILE: /^(044|045)?\s*(\d{2})\s*(\d{4})\s*(\d{4})$/,
   MEXICO_LANDLINE: /^(\d{2,3})\s*(\d{4})\s*(\d{4})$/,
   INTERNATIONAL: /^\+(?:[0-9]●?){6,14}[0-9]$/,
   E164: /^\+[1-9]\d{1,14}$/,
 } as const;